export default __webpack_public_path__ + "static/media/file-ic.56009fd6.svg";